import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./app/App.tsx";
import AppErrorBoundary from "./app/AppErrorBoundary.tsx";

// Dev/E2E-only: install the Playwright test seam (window.__e2e). The dynamic
// import is guarded so the module is never bundled into production builds.
if (import.meta.env.DEV) {
  // Dev/E2E seam only (tree-shaken from prod). Top-level await would read
  // cleaner but the es2020 build target rejects it, so we load via an async
  // IIFE instead. NOSONAR S7785 — top-level await is unavailable here.
  (async () => {
    const { installE2ETestSeam } = await import(
      "./app/shared/testing/e2eTestSeam"
    );
    installE2ETestSeam();
  })().catch(() => undefined); // NOSONAR
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
